import React from "react";
import PropTypes from "prop-types";
import { Box, HStack, Text, VStack } from "native-base";
import Modal from "../modal";
import colors from "../../constants/colors";

function ConfirmationModal(props) {
  const { isOpen, onRequestClose, onContinue, isLoading } = props;

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <VStack paddingX={10} paddingY={5} space={5} alignItems="center">
        <Text textAlign="center">
          ¿Está seguro de que desea continuar con la hora de inicio a las 00:00?
        </Text>
        <HStack space={5} width="full">
          <button
            className="flex-1"
            onClick={onRequestClose}
            disabled={isLoading}>
            <Box
              backgroundColor={colors.primary}
              paddingY={3}
              borderRadius="full">
              <Text color={colors.white}>No</Text>
            </Box>
          </button>
          <button className="flex-1" onClick={onContinue} disabled={isLoading}>
            <Box
              backgroundColor={colors.primary}
              paddingY={3}
              borderRadius="full">
              <Text color={colors.white}>Si</Text>
            </Box>
          </button>
        </HStack>
      </VStack>
    </Modal>
  );
}

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default React.memo(ConfirmationModal);
